import { render, staticRenderFns } from "./DgWrap.vue?vue&type=template&id=03c77216&scoped=true"
import script from "./DgWrap.vue?vue&type=script&lang=js"
export * from "./DgWrap.vue?vue&type=script&lang=js"
import style1 from "./DgWrap.vue?vue&type=style&index=1&id=03c77216&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c77216",
  null
  
)

export default component.exports